import cx from "classnames";
import React from "react";

export type SummaryProps = {
  summary: string;
};

const Summary = ({ summary }: SummaryProps) => {
  if (!summary) {
    return null;
  }
  const styles = cx(
    "max-w-container py-16 mx-auto font-bold leading-tight text-[color:var(--summary-text-color)] px-6 md:text-[2.5rem]",
    "[text-align:var(--summary-text-align)]",
    "[text-transform:var(--summary-case)]",
    "[font-family:var(--summary-font)]",
    "[font-style:var(--summary-font-style)]",
    "[font-weight:var(--summary-font-weight)]",
    "md:[font-size:var(--summary-text-size-desktop)]",
    "[font-size:var(--summary-text-size-mobile)]"
  );
  return (
    <div
      data-cy="summary-text"
      className="bg-[color:var(--summary-bg-color)] summary-updated"
    >
      <div className={styles}>
        <p>{summary}</p>
      </div>
    </div>
  );
};

export default Summary;
